export const techIcons = {
    ReactJS:
        "https://res.cloudinary.com/delp8ph1h/image/upload/v1662899293/portfolio/react.svg",
    Redux: "https://res.cloudinary.com/delp8ph1h/image/upload/v1662899293/portfolio/redux.svg",
    FastUI: "https://res.cloudinary.com/delp8ph1h/image/upload/v1662901373/portfolio/fast-ui.png",
    Firebase:
        "https://res.cloudinary.com/delp8ph1h/image/upload/v1662899293/portfolio/firebase.svg",
    HTML5: "https://res.cloudinary.com/delp8ph1h/image/upload/v1662899293/portfolio/html.svg",
    CSS3: "https://res.cloudinary.com/delp8ph1h/image/upload/v1662899293/portfolio/css3.svg",
    NodeJS: "https://res.cloudinary.com/delp8ph1h/image/upload/v1662899295/portfolio/node-js.svg",
    MongoDB:
        "https://res.cloudinary.com/delp8ph1h/image/upload/v1662899294/portfolio/mongodb.svg",
};
